import type { FC } from 'react';
import {
  DevHubDialog,
  DevHubDialogTitle,
  DevHubDialogContent,
  DevHubDialogActions,
  DevHubButton,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';

export interface SwitchConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Switch confirmation dialog component
 * @param param0 - Props for the component
 * @returns SwitchConfirmDialog JSX element
 */
export const SwitchConfirmDialog: FC<SwitchConfirmDialogProps> = ({
  open,
  onCancel,
  onConfirm,
}) => {
  return (
    <DevHubDialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DevHubDialogTitle>Confirm Functional Area Switch</DevHubDialogTitle>

      <DevHubDialogContent>
        <DevHubTypography variant="body1" style={{ marginBottom: '1rem' }}>
          You have pending changes in the current functional area that will be
          lost if you switch.
        </DevHubTypography>

        <DevHubTypography variant="body2" style={{ color: '#f57c00' }}>
          <strong>Warning:</strong> All unsaved changes will be discarded. Are
          you sure you want to continue?
        </DevHubTypography>
      </DevHubDialogContent>

      <DevHubDialogActions>
        <DevHubButton onClick={onCancel} variant="outlined">
          Cancel
        </DevHubButton>
        <DevHubButton onClick={onConfirm} variant="contained" color="primary">
          Discard Changes & Switch
        </DevHubButton>
      </DevHubDialogActions>
    </DevHubDialog>
  );
};
